document.addEventListener('DOMContentLoaded', function () {
  // SERIAL VALIDATION
  // -----------------------------------------------------------------------------------------------------------------
  // GRAYLOON

  // BASIC SERIAL CHECK
  async function checkSerialAvailability(serial) {
    try {
      const response = await fetch('https://api.hoyt.com/api/shopify/warranty-registrations/check-serial', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': 'cXne38yNkxmGFaRDq7hbcPs8',
        },
        body: JSON.stringify({
          serial: serial,
        }),
      });

      if (!response.ok) {
        throw new Error('API request failed');
      }

      const data = await response.json();

      return data;
    } catch (error) {
      console.error('Serial check error:', error);
      return {
        available: false,
        message: 'Unable to verify serial number. Please try again.',
      };
    }
  }

  // VALIDATE SERIAL (format + availability). Returns true if the serial is
  // valid and not already registered. Used on blur and re-checked on submit,
  // since submission must not rely on the field having been blurred first.
  async function validateSerialNumber(serial) {
    if (!serial) return true;

    // First validate format (7-8 alphanumeric characters)
    const serialRegex = /^[A-Za-z0-9]{7,8}$/;

    if (serial.length < 7 || serial.length > 8 || !serialRegex.test(serial)) {
      showSerialValidation({
        available: false,
        message: 'Serial numbers must be exactly 7 or 8 characters.',
      });
      return false;
    }

    // If format is valid, check availability
    const result = await checkSerialAvailability(serial);

    showSerialValidation(result);

    return !!result.available;
  }

  // VALIDATE SERIAL ON BLUR
  const serialInput = document.querySelector('#serialNumber');

  serialInput.addEventListener('blur', async function () {
    const serial = serialInput.value.trim();

    if (!serial) return;

    await validateSerialNumber(serial);
  });

  // DISPLAY ERROR/SUCCESS
  function showSerialValidation(result) {
    const wrapper = document.querySelector('#serialNumber').closest('.field-wrapper');

    let error = wrapper.querySelector('.error-message');

    if (!error) {
      error = document.createElement('div');
      error.className = 'error-message';
      wrapper.appendChild(error);
    }

    if (!result.available) {
      wrapper.classList.add('error');
      error.innerHTML = result.message || 'This serial number has already been registered.';
    } else {
      wrapper.classList.remove('error');
      error.innerHTML = '';
    }
  }
  // -----------------------------------------------------------------------------------------------------------------
  // -----------------------------------------------------------------------------------------------------------------

  // FORM SUBMISSION
  // -----------------------------------------------------------------------------------------------------------------
  document.getElementById('bow-registration-form').addEventListener('submit', async function (e) {
    e.preventDefault();

    // Validate required + length constraints before submission (native
    // validation already guarantees this for a first attempt, but a prior
    // blocked attempt can leave stale .error classes on fields that have
    // since been fixed -- and autofill can bypass maxlength/focus events --
    // so every submit attempt re-checks and re-applies error state fresh.
    let hasError = false;
    const fieldsToCheck = this.querySelectorAll('input[required], select[required], input[maxlength], select[maxlength]');
    fieldsToCheck.forEach(function (field) {
      const wrapper = field.closest('.field-wrapper');
      if (!wrapper) return;

      const value = field.value.trim();
      const max = parseInt(field.getAttribute('maxlength'), 10);
      const isEmpty = field.hasAttribute('required') && value === '';
      const isTooLong = max && value.length > max;

      if (isEmpty || isTooLong) {
        wrapper.classList.add('error');
        hasError = true;
      } else {
        wrapper.classList.remove('error');
      }
    });

    // Serial number must be valid format and not already registered
    const serialValid = await validateSerialNumber(serialInput.value.trim());
    if (!serialValid) hasError = true;

    if (hasError) {
      const firstError = document.querySelector('.field-wrapper.error');
      if (firstError) {
        firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
        const input = firstError.querySelector('input, select, textarea');
        if (input) input.focus();
      }
      return;
    }

    const messageEl = document.getElementById('form-message');
    messageEl.textContent = 'Submitting...';

    const payload = {
      firstname: document.getElementById('firstName').value,
      middle: document.getElementById('middleInitial').value,
      lastname: document.getElementById('lastName').value,
      country: document.getElementById('country').value,
      address: document.getElementById('address').value,
      city: document.getElementById('city').value,
      state: document.getElementById('state').value,
      province: document.getElementById('province').value,
      otherstate: document.getElementById('otherState').value,
      zip: document.getElementById('zip').value,
      area: document.getElementById('areaCode').value,
      phone: document.getElementById('phone').value,
      email: document.getElementById('email').value,
      age: document.getElementById('age').value,
      gender: document.getElementById('gender').value,
      bowType: document.getElementById('bowType').value,
      serial: document.getElementById('serialNumber').value,
      purchasePlace: document.getElementById('placeOfPurchase').value,
      purchaseDate: document.getElementById('datePurchased').value,
      receiveEmails: document.getElementById('newsletter').value,
    };

    const proofFile = document.getElementById('proofOfPurchase').files[0];
    if (proofFile) {
      const base64 = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(proofFile);
      });
      payload.proofOfPurchase = base64;
      payload.proofOfPurchaseFilename = proofFile.name;
    }

    try {
      const response = await fetch('https://api.hoyt.com/api/shopify/warranty-registrations', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': 'cXne38yNkxmGFaRDq7hbcPs8',
        },
        body: JSON.stringify(payload),
      });

      const data = await response.json();

      if (data.success) {
        document.getElementById('bow-registration-form').style.display = 'none';
        document.getElementById('form-message').style.display = 'none';
        document.getElementById('bow-registration-success').style.display = 'block';
      } else if (data.errors) {
        const firstError = Object.values(data.errors)[0][0];
        messageEl.textContent = firstError;
      } else {
        messageEl.textContent = 'Unexpected response.';
      }
    } catch (error) {
      console.error('Network error:', error);
      messageEl.textContent = 'Submission failed. Please try again.';
    }
  });
  // -----------------------------------------------------------------------------------------------------------------
  // -----------------------------------------------------------------------------------------------------------------
});
